import "./AboutMe.module.css";
import Encabezado from "@/reusable_sections/Header";
import HeroPersonal from "./sections/HeroPersonal";
import MiHistoriaYEnfoque from "./sections/MiHistoriaYEnfoque";
import InvitacionAReservar from "./sections/InvitacionAReservar";
import PieDePA_gina from "@/reusable_sections/Footer";
export default function AboutMePage() {
  return <div>
      <Encabezado />
      <HeroPersonal />
      <MiHistoriaYEnfoque />
      <InvitacionAReservar />
      <PieDePA_gina />
    </div>;
}